import { defineMessages } from '../../i18n/messages';

export const FinalCTAMessages = defineMessages({
  TITLE: {
    id: 'homepage.final_cta.title_v2',
    text: 'Localize faster. Start free today.',
    description: 'Headline for the final call-to-action section at the bottom of the homepage. Should feel urgent and encouraging. This is the last section before the footer. Avoids the word "trial" deliberately: the free tier is limited by word usage, not by time.',
  },
  /*
   * Was "Join developers and product teams who trust Localingos for fast, reliable,
   * variable-safe translations." This component had never been rendered, so the claim
   * had never been made — and it should not start being made now: it implies an
   * existing body of customers, and there is not one. What is left describes what the
   * product does, which is checkable.
   */
  SUBTITLE: {
    id: 'homepage.final_cta.subtitle_v2',
    text: 'One command pushes your strings and pulls back translations with every placeholder intact.',
    description: 'Subtitle for the closing call-to-action. Describes the product\'s core behaviour rather than claiming existing customers. "Placeholder" means a code variable such as {{name}} that must survive translation unchanged.',
  },
  BTN_VIEW_PRICING: {
    id: 'homepage.final_cta.btn_view_pricing',
    text: 'View pricing',
    description: 'Secondary button in the closing call-to-action section of the homepage. Leads to the pricing page.',
  },
  NOTE: {
    id: 'homepage.final_cta.note',
    text: 'Free tier, 5,000 words included, no credit card. Words count once per language you translate into.',
    description: 'Reassurance line under the closing call-to-action buttons. States the free allowance and, importantly, that usage is multiplied by the number of target languages so the figure is not mistaken for a whole-app budget.',
  },
});
